var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
if (!customElements.get("ona-number-input")) {
  class OnaNumberInput extends HTMLElement {
    constructor() {
      super();
      this._debounceDelay = 0;
      this._debounceTimer = null;
      this.attachShadow({ mode: "open" });
      this.shadowRoot.innerHTML = `
        <style>
          input[type="number"] {
            appearance: textfield;
          }
          input[type=number]::-webkit-outer-spin-button,
          input[type=number]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
          button {
            background: transparent;
            border: none;
            margin: 0;
            padding: 0;
            cursor: pointer;
          }
          button:disabled,
          input:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        </style>
        <button type="button" part="button remove-button" data-action="remove" aria-label="Decrease">
          <slot name="remove">-</slot>
        </button>
        <input type="number" part="input" aria-label="Number input">
        <button type="button" part="button add-button" data-action="add" aria-label="Increase">
          <slot name="add">+</slot>
        </button>
      `;
    }
    connectedCallback() {
      this.input = this.shadowRoot.querySelector("input");
      this.input.value = this.getAttribute("value") || 0;
      this.input.addEventListener("input", () => this._handleInputChange());
      this.input.addEventListener("keydown", this._onKeydown.bind(this));
      this.buttons = this.shadowRoot.querySelectorAll("button");
      this.buttons.forEach((btn) => btn.addEventListener("click", () => this._changeValue(btn.dataset.action)));
      this._updateDebounce();
      this._updateAttributes();
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (!this.input) return;
      if (name === "debounce") {
        this._updateDebounce();
      }
      if (name === "value" && this.input.value !== newValue) {
        this.input.value = newValue;
      }
      this._updateAttributes();
    }
    _updateDebounce() {
      const delay = parseInt(this.getAttribute("debounce"), 10);
      this._debounceDelay = isNaN(delay) ? 0 : delay;
    }
    _updateAttributes() {
      var _a, _b, _c;
      this.input.min = (_a = this.getAttribute("min")) != null ? _a : "";
      this.input.max = (_b = this.getAttribute("max")) != null ? _b : "";
      this.input.value = (_c = this.getAttribute("value")) != null ? _c : 0;
      this.input.disabled = this.hasAttribute("disabled");
      this.input.readOnly = this.hasAttribute("readonly");
      this.buttons.forEach((btn) => {
        btn.disabled = this.hasAttribute("disabled");
      });
    }
    _changeValue(action) {
      if (this.hasAttribute("disabled")) return;
      const step = 1;
      const current = parseInt(this.input.value, 10) || 0;
      const min = this.hasAttribute("min") ? parseInt(this.getAttribute("min"), 10) : -Infinity;
      const max = this.hasAttribute("max") ? parseInt(this.getAttribute("max"), 10) : Infinity;
      let next = action === "add" ? current + step : current - step;
      next = Math.max(min, Math.min(max, next));
      if (next !== current) {
        this.input.value = next;
        this._handleInputChange();
      }
    }
    _onKeydown(e) {
      if (this.hasAttribute("disabled") || this.hasAttribute("readonly")) return;
      if (e.key === "ArrowUp") {
        e.preventDefault();
        this._changeValue("add");
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        this._changeValue("remove");
      }
    }
    _handleInputChange() {
      if (this._debounceDelay > 0) {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => this._emitChange(), this._debounceDelay);
      } else {
        this._emitChange();
      }
    }
    _emitChange() {
      this.dispatchEvent(
        new CustomEvent("change", {
          detail: { value: Number(this.input.value) },
          bubbles: true,
          composed: true
        })
      );
    }
    // Property access
    get value() {
      var _a, _b, _c;
      return Number((_c = (_b = (_a = this.input) == null ? void 0 : _a.value) != null ? _b : this.getAttribute("value")) != null ? _c : 0);
    }
    set value(val) {
      this.setAttribute("value", val);
      if (this.input) {
        this.input.value = val;
      }
    }
  }
  __publicField(OnaNumberInput, "observedAttributes", ["min", "max", "value", "disabled", "readonly", "debounce"]);
  customElements.define("ona-number-input", OnaNumberInput);
}
